import * as React from 'react';
const TossineInEccessoIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M100.46 94.44v20.38s9.26 0 9.26-7.41V88.89c0-3.7-.64-7.41-9.26-7.41-5.56 0-11.11 1.85-14.53 5.21-6.88 6.77-14.19 13.25-14.19 18 0 4.45 3.27 7.09 6.9 10.34 3.9 3.51 10.34 8.62 10.34 8.62l-3.32 18.97M94.29 142.61l5.8-21.2M94.29 110.55l-3.58-3.29M100.46 98.15l-9.75 9.11"
      className="prefix__cls-2"
    />
    <circle cx={121.77} cy={84.25} r={6.48} className="prefix__cls-2" />
    <path
      d="m72.68 108.52 5.97 16.72-3.32 17.37M87.55 104.25l3.16 3.01"
      className="prefix__cls-2"
    />
    <path
      d="M88.79 74.07c6.12-9.26-6.85-7.41 2.17-16.67M99.9 74.07c6.12-9.26-6.85-7.41 2.17-16.67M111.02 74.07c6.12-9.26-6.85-7.41 2.17-16.67"
      className="prefix__cls-1"
    />
  </svg>
);
export default TossineInEccessoIcon;
